'use client'

import { useCallback } from 'react'
import { useTranslations } from '@repo/core/i18n'
import Cookies from 'js-cookie'
import type { Locale } from './config'
import { locales, defaultLocale } from './config'

export { useTranslations }

export function useLocale(): Locale {
  const locale = Cookies.get('NEXT_LOCALE') as Locale | undefined
  return locale && locales.includes(locale) ? locale : defaultLocale
}

export function useChangeLocale() {
  const changeLocale = useCallback((newLocale: Locale) => {
    Cookies.set('NEXT_LOCALE', newLocale, { expires: 365 })
    window.location.reload()
  }, [])

  return changeLocale
}

export function getLocale(): Locale {
  if (typeof window === 'undefined') return defaultLocale
  const locale = Cookies.get('NEXT_LOCALE') as Locale | undefined
  return locale && locales.includes(locale) ? locale : defaultLocale
}

export function setLocale(locale: Locale) {
  Cookies.set('NEXT_LOCALE', locale, { expires: 365 })
}
